'use client'

import { useCallback, useRef } from 'react'

import { mapManager } from './map-manager'

export const useMapPin = () => {
  const markerRef = useRef<naver.maps.Marker | null>(null)

  const createMapPin = useCallback(
    ({ lat, lng }: { lat: number; lng: number }) => {
      mapManager.withMap(map => {
        if (!markerRef.current) {
          markerRef.current = new naver.maps.Marker({
            position: new naver.maps.LatLng(lat, lng),
            map,
            clickable: false,
            icon: {
              url: '/icon/map-pin.svg',
              size: new window.naver.maps.Size(40, 40),
              anchor: new window.naver.maps.Point(20, 40),
            },
          })
        } else {
          markerRef.current.setPosition(new naver.maps.LatLng(lat, lng))
        }
      })
    },
    [],
  )

  const removeMapPin = useCallback(() => {
    if (markerRef.current) {
      markerRef.current.setMap(null)
      markerRef.current = null
    }
  }, [])

  return { createMapPin, removeMapPin }
}
